import { StrictMode } from 'react'
import './index.css'


import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

// Create a new router instance
const router = createRouter({ routeTree })

import { MsalProvider } from "@azure/msal-react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const TENANT_ID = import.meta.env.VITE_MSAL_TENANT_ID;
const APP_ID = import.meta.env.VITE_MSAL_APP_ID;

const configuration: Configuration = {
  auth: {
    clientId: APP_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin

  },
  cache: {
    storeAuthStateInCookie: true
  }
};

const pca = new PublicClientApplication(configuration);

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <MsalProvider instance={pca}>
        <RouterProvider router={router} />
      </MsalProvider>
    </StrictMode>,
  )
}
